import { history } from "@/api/history";

const state = {
  historyDetail: {},   // 设备历史数据
  startTime: '',
  historyRadio: '',
  historyParam: {}
};

const getters = {
  historyDetail: state => state.historyDetail,
  historyRadio: state => state.historyRadio
};

const mutations = {
  HISTORY_DETAIL(state, data) {
    state.historyDetail = data;
  },
  HISTORY_STARTTIME(state, time) {
    state.startTime = time;
  },
  HISTORY_RADIO(state, radio) {
    state.historyRadio = radio;
  },
};

const actions = {
  // 历史图表数据
  historyGraphic({commit}, param) {
    return new Promise((resolve, reject) => {
      history(param).then(res => {
        commit('HISTORY_DETAIL', res)
        resolve();
      }).catch((error) => {
          reject(error);
        });
    });
  },

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/history.js